export default __webpack_public_path__ + "static/media/1544.8afd7856.png";